module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 13-e8a616c98a178c2b8b366068f1151106.webp";